import utils from "@/libs/utils";
// import router from '@/router'
import Cookies from "js-cookie";

export const MODULE_NAME_ENUM = {
  yuewen: "yuewen",
  tengman: "tencent-comics",
};
export const AREA_NAME_ENUM = {
  ios: "iOS",
  android: "android",
};
export const MODULE_NAME_LIST = Object.values(MODULE_NAME_ENUM);

export const getModuleName = (): string => {
  const { pathname = "" } = window.location;
  return pathname.split("/")[1] || "";
};

export const getCookie = (name: string): string => {
  return Cookies.get(name) || "";
};

export const setCookie = (
  name: string,
  value: string,
  expires: number,
  path: string
): void => {
  Cookies.set(name, value, { expires, path });
};

export const URL_PREFIX = String(import.meta.env.VITE_APP_AXIOS_BASE_URL || "");

export const OLD_M_URL = String(import.meta.env.VITE_APP_OLD_M_URL || "");

export const isDevMode =
  import.meta.env.VITE_APP_MODE === "test" ||
  import.meta.env.VITE_APP_MODE === "dev";

export const isInIphonex = utils.isPhoneX();

/** 是否为筑梦岛App */
export const isZMD = getCookie("appid") === "100";

export const isNeedUpdate = (): boolean => {
  // 起点 安卓版本784，IOS版本494
  if (utils.isQDIosByUA()) {
    if (getCookie("appid") === "26" || getCookie("appId") === "26") {
      return !(jssdk.versionCode >= 494);
    }
    false;
  }
  if (utils.isQDAndroidByUA()) {
    if (getCookie("appid") === "12" || getCookie("appId") === "12") {
      return !(jssdk.versionCode >= 784);
    }
    false;
  }
  return false;
};

export const getBasicData = (): {
  // ywguid: string;
  // ywkey: string;
  appid: string;
  areaid: string;
  imei: string;
  qimei: string;
  version: string;
} => {
  if (!getCookie("ywguid") || !getCookie("ywkey")) {
    let loginUrl = String(import.meta.env.VITE_APP_LOGIN || "");
    const returnUrl = utils.getQueryStringByName(loginUrl, "returnurl");
    // verifyuser路径携带query参数
    if (window.location.href.includes("verifyuser")) {
      loginUrl = loginUrl.replace(
        `returnurl=${returnUrl}`,
        `returnurl=${encodeURIComponent(window.location.href)}`
      );
    }
    // console.log(
    //   "returnUrl",
    //   returnUrl,
    //   window.location.href.includes("verifyuser"),
    //   loginUrl.slice(-20)
    // );
    window.location.href = loginUrl;
  }

  const app_appid = getCookie("appid") || getCookie("appId") || "37";
  // QQ阅读 版本号
  const qq_version = String(getCookie("c_version")) || "";
  let matchArr, versionFir, versionFourth, versionSec, versionThird;
  // 非指定端内内打开均不走老M站url
  /**
   * 12/26 起点端内
   * 100686853 QQ阅读
   * 37 安全中心
   */
  if (utils.isIosByUA() || utils.isAndroidByUA() || utils.isHarmonyByUA()) {
    switch (app_appid) {
      case "12":
        // 起点 安卓
        break;
      case "26":
        // 起点 iOS
        break;
      case "92":
        // 起点鸿蒙
        break;
      // QQ阅读 判断cookie里面的 c_version
      /**
       * params cookie里面的 c_version 格式规范如下
       * qqreader_xx.xx.xx.xx_android
       * qqreader_xx.xx.xx.xx_iphone
       */
      case "1450000219":
        // QQ阅读 安卓
        // QQ阅读 安卓 1450000219 >= 7.9.9.0900
        if (
          qq_version &&
          /^qqreader\_[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+\_android$/g.test(
            qq_version
          )
        ) {
          matchArr = qq_version.match(/\d+/g);
          versionFir = (matchArr && parseInt(matchArr[0])) || 0;
          versionSec = (matchArr && parseInt(matchArr[1])) || 0;
          versionThird = (matchArr && parseInt(matchArr[2])) || 0;
          versionFourth = (matchArr && parseInt(matchArr[3])) || 0;
          if (
            versionFir > 7 ||
            (versionFir === 7 && versionSec > 7) ||
            (versionFir === 7 && versionSec === 9 && versionThird > 9) ||
            (versionFir === 7 &&
              versionSec === 9 &&
              versionThird === 9 &&
              versionFourth >= 900)
          ) {
            // 新版本
          } else {
            // 旧版本，跳老的
            window.location.href = String(import.meta.env.VITE_APP_OLD_M_URL);
          }
        }
        break;
      case "1450000540":
        // QQ阅读 iOS
        // QQ阅读 iOS 1450000540 >= 7.9.92
        if (
          qq_version &&
          /^qqreader\_[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+\_iphone$/g.test(qq_version)
        ) {
          matchArr = qq_version.match(/\d+/g);
          versionFir = (matchArr && parseInt(matchArr[0])) || 0;
          versionSec = (matchArr && parseInt(matchArr[1])) || 0;
          versionThird = (matchArr && parseInt(matchArr[2])) || 0;
          if (
            versionFir > 7 ||
            (versionFir === 7 && versionSec > 9) ||
            (versionFir === 7 && versionSec === 9 && versionThird >= 92)
          ) {
            // 新版本
          } else {
            // 旧版本，跳老的
            window.location.href = String(import.meta.env.VITE_APP_OLD_M_URL);
          }
        }
        break;
      case "100":
        // 筑梦岛
        break;
      case "37":
        // 兜底默认
        break;
      default:
        window.location.href = String(import.meta.env.VITE_APP_OLD_M_URL);
        break;
    }
  }

  return {
    // ywguid: getCookie("ywguid"),
    // ywkey: getCookie("ywkey"),
    appid: app_appid,
    areaid: getCookie("areaid") || getCookie("areaId") || "2",
    imei: getCookie("imei"),
    qimei: getCookie("qimei"),
    version: "1.0",
  };
};
